<template>
  <HostCards v-model="$attrs.value" :service="entity" header="" ref="component" @input="onInput" />
</template>

<script>
  import FormField from '@/mixins/FormField'
  import HostCards from '@/components/cards/Hosts'

  export default {
    name: 'FormServiceHosts',
    mixins: [
      FormField,
    ],
    components: {
      HostCards,
    },
  }
</script>
